window.app.controller('blogCtrl', ['$scope', '$http', function ($scope, $http) {

    $scope.articles = [];
    $scope.categoryId;
    $scope.categoryName;
    $scope.categoryAlias = false;

    $scope.getAllArticles = () => {
        $scope.sendXHR({
            url: `/api/front/blog/blog/get-posts`,
            data: '',
            successFunc: $scope.saveArticles
        });
    }

    $scope.getCategoryArticles = () => {
        $scope.sendXHR({
            url: `/api/front/blog/blog/get-category-posts`,
            data: { "id": $scope.categoryId },
            successFunc: (resp) => {
                $scope.categoryName = resp.data.category.name;
                $scope.categoryAlias = resp.data.category.alias;
                $scope.saveArticles(resp);
            }
        });
    }

    class articalPreviewHtml {
        constructor(categoryName, categoryAlias, title, id, articleAlias, body) {
            this.categoryName = categoryName;
            this.categoryAlias = categoryAlias;
            this.title = title;
            this.id = id;
            this.articleAlias = articleAlias;
            this.body = body;
        }

        RemoveHTMLTags(html) {
            let regX = /(<([^>]+)>)/ig;
            html = html.replace(regX, "");
            return html.slice(0, 346);
        }

        renderHtml() {
            return `<div class="blog-card has-padding-y1" layout layout-xs="column">
                        <div class="blog-card-img ${this.categoryName}" flex="30" flex-xs="100">
                            <a href="/wiadomosci/${this.categoryAlias}/${this.articleAlias}">
                                <img alt="${this.title}" class="has-padding-x1" src="/web/uploads/img/blog/${this.id}/mainImage.png">
                            </a>
                        </div>
                        <div class="has-padding-x1 blog-card-body" flex="70" flex-xs="100">
                            <a href="/wiadomosci/${this.categoryAlias}/${this.articleAlias}"><h3>${this.title}</h3></a>
                            <p class="has-margin-y1 multiline-overflow">
                                ${this.RemoveHTMLTags(this.body)}...
                            </p>
                            <a class="action-btn" href="/wiadomosci/${this.categoryAlias}/${this.articleAlias}">Czytaj więcej</a>
                        </div>
                    </div>`
        }
    }

    $scope.$watch('articles', function () {
        if ($scope.articles.length !== 0) {
            $('#pagination').pagination({
                dataSource: $scope.articles,
                pageSize: 10,
                pageRange: 3,
                callback: (data, pagination) => {
                    var html = $scope.createTemplate(data);
                    $('#articles').html(html);
                }
            })
        }
    })

    $scope.createTemplate = (data) => {
        var dataHtml = '';
        if ($(".all-articles").length !== 0) {
            $.each(data, function (index, article) {
                let oneArticle = new articalPreviewHtml(article.category_name, article.category_alias, article.title, article.id, article.alias, article.body)
                dataHtml += oneArticle.renderHtml();
            })
        } else {
            $.each(data, function (index, article) {
                let oneArticle = new articalPreviewHtml($scope.categoryName, $scope.categoryAlias, article.title, article.id, article.alias, article.body)
                dataHtml += oneArticle.renderHtml();
            })
        }
        return dataHtml;
    }

    $scope.saveArticles = (resp) => {
        $scope.articles = resp.data.posts;
    }

    $scope.findSelectedCategory = () => {
        let href = window.location.href;
        href.includes("porady-finansowe") ? $scope.categoryId = 2 : $scope.categoryId = 1;
    }

    $scope.styleCategoriesButtons = () => {
        if ($scope.categoryId === 2) {
            $(".categories > .porady-finansowe").addClass("active")
        } else if ($scope.categoryId === 1) {
            $(".categories > .aktualnosci").addClass("active")
        }
    }

    if ($(".category-ctn").length !== 0) {
        $scope.findSelectedCategory();
        $scope.styleCategoriesButtons();
    }

    // $scope.filtersAsideHeight = () => {
    //     $(window).on('load scroll resize mouseover', function() {
    //         if(window.innerWidth >= 993){
    //             console.log($('.fin-offers'))
    //             let el = $('.fin-offers'),
    //                 scrollTop = $(this).scrollTop(),
    //                 scrollBot = scrollTop + $(this).height(),
    //                 elTop = el.offset().top,
    //                 elBottom = elTop + el.outerHeight(),
    //                 visibleTop = elTop < scrollTop ? scrollTop : elTop,
    //                 visibleBottom = elBottom > scrollBot ? scrollBot : elBottom,
    //                 height = $('aside').hasClass('sticky') ? visibleBottom - visibleTop - 75 : visibleBottom - visibleTop - 10;
    //             $('.offers-filters--aside').css('height', height+'px')
    //         }
    //     });
    // };

    // $( document ).ready(function() {
    //     $scope.filtersAsideHeight();
    // })


}])


// WEBPACK FOOTER //
// src/js/controllers/blog/blogCtrl.js